import { useState, useEffect } from "react";
import { SpotlightAudio } from "../../shared/types";
import "./styles.scss";

interface IAudioBookDrawer {
  onClose: () => void;
  onSpotlightClick: (data: SpotlightAudio) => void;
}

export const AudioBookDrawer = ({ onClose, onSpotlightClick }: IAudioBookDrawer) => {
  const [formData, setFormData] = useState<any>({
    cookie: "",
    ttsURL: "",
    wordHighlightColor: "lightblue",
    sentenceHighlightColor: "beige",
    maxSpotlights: "",
  });

  // Load saved data from localStorage on component mount
  useEffect(() => {
    const savedData = localStorage.getItem("audioBookDrawerData");
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setFormData((prev: any) => ({
          ...prev,
          ...parsedData,
        }));
      } catch (error) {
        console.error("Error parsing saved data from localStorage:", error);
      }
    }
  }, []);

  // Save data to localStorage whenever formData changes
  useEffect(() => {
    localStorage.setItem("audioBookDrawerData", JSON.stringify(formData));
  }, [formData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    // Update the formData state dynamically
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!formData.ttsURL) {
      alert("TTS URL is mandatory");
      return;
    }

    try {
      // strip last segment
      const ttsURL = new URL(formData.ttsURL.replace(/\/[^/]*$/, "")).toString();

      formData.cookie.split(";").forEach((pair: string) => {
        const trimmed = pair.trim();
        if (trimmed) {
          document.cookie = `${trimmed}; path=/; SameSite=Lax`;
        }
      });

      onSpotlightClick({
        ttsURL,
        wordHighlightColor: formData.wordHighlightColor,
        sentenceHighlightColor: formData.sentenceHighlightColor,
        maxSpotlights: formData.maxSpotlights ? parseInt(formData.maxSpotlights, 10) : undefined,
      });

      onClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="drawer spotlight-drawer">
      <div className="header">
        <h3 className="title">Spotlight</h3>
        <button className="close-button" aria-label="Close button" onClick={onClose}>
          <div className="close-icon" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="drawer-body">
        <div className="field">
          <label htmlFor="sentenceHighlightColor" className="label">
            Sentence Highlight Color
          </label>
          <input
            type="text"
            name="sentenceHighlightColor"
            aria-label="Sentence Highlight Color"
            value={formData.sentenceHighlightColor}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label className="label">Word Highlight Color</label>
          <input
            type="text"
            name="wordHighlightColor"
            value={formData.wordHighlightColor}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label htmlFor="maxSpotlights" className="label">
            Max Spotlights
          </label>
          <input
            type="number"
            name="maxSpotlights"
            aria-label="Max Spotlights"
            value={formData.maxSpotlights}
            onChange={handleChange}
            placeholder="Enter maximum number of spotlights"
          />
        </div>

        <div className="field">
          <label className="label">P+ TTS URL</label>
          <textarea rows={6} name="ttsURL" value={formData.ttsURL} onChange={handleChange} />
        </div>

        <div className="field">
          <label className="label">P+ Cookie</label>
          <textarea rows={6} name="cookie" value={formData.cookie} onChange={handleChange} />
        </div>

        <button type="submit" aria-label="Spotlight">
          Spotlight
        </button>
      </form>
    </div>
  );
};
